module.exports = __webpack_public_path__ + "static/img/course_selection_widget_2.5716baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/course_selection_widget_2.png
// module id = Gydx
// module chunks = 11